'use client';

import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';

if (
    typeof window !== 'undefined' &&
    process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN &&
    process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID
) {
    datadogLogs.init({
        clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN || '',
        site: 'datadoghq.eu',
        service: 'frontend',
        env: process.env.NEXT_PUBLIC_ENV || 'production',
        version: process.env.NEXT_PUBLIC_APP_VERSION || '0.0.0',
        forwardErrorsToLogs: true,
        forwardConsoleLogs: ['error', 'warn'],
        forwardReports: ['intervention', 'deprecation'],
        useSecureSessionCookie: true,
        usePartitionedCrossSiteSessionCookie: true,
        allowFallbackToLocalStorage: true,
        sessionPersistence: 'local-storage',
    });

    datadogRum.init({
        applicationId: process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID || '',
        clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN || '',
        site: 'datadoghq.eu',
        service: 'frontend',
        env: process.env.NEXT_PUBLIC_ENV || 'production',
        version: process.env.NEXT_PUBLIC_APP_VERSION || '0.0.0',
        sessionSampleRate: 100,
        sessionReplaySampleRate: 100,
        defaultPrivacyLevel: 'allow',
        trackResources: true,
        trackLongTasks: true,
        trackUserInteractions: true,
        trackEarlyRequests: true,
        compressIntakeRequests: true,
        allowedTracingUrls: [
            {
                match: (url: string) => url.startsWith(process.env.NEXT_PUBLIC_API_URL || ''),
                propagatorTypes: ['tracecontext', 'datadog'],
            },
        ],
        traceSampleRate: 100,
        traceContextInjection: 'sampled',
        allowedGraphQlUrls: [
            {
                match: (url: string) => url.startsWith(process.env.NEXT_PUBLIC_API_URL || ''),
                trackPayload: true,
                trackResponseErrors: true,
            },
        ],
        useSecureSessionCookie: true,
        usePartitionedCrossSiteSessionCookie: true,
        allowFallbackToLocalStorage: true,
        sessionPersistence: 'local-storage',
    });

    datadogRum.startSessionReplayRecording();
}

export default function DatadogInit() {
    return null;
}
